import Exception from '../lang/Exception.js'

export default class IOException extends Exception { }